import script from "./ProjectBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectBanner.vue?vue&type=script&setup=true&lang=js"

import "./ProjectBanner.vue?vue&type=style&index=0&id=9cfe2d64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cfe2d64"]])

export default __exports__